<template>  
  <div class="card-orcamento-informacao">
    <g-card :temCabecalho="false" :expansivel="false" :temBordaTopProps="this.tituloDetalhes">      
      <div v-if="tituloDetalhes" class="header-detalhes-secundario cabecalho-detalhes">        
        <div class="header-detalhes-secundario-titulo">          
          <g-button
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            altura="30px"
            cor="#FFFFFF"
            :sombreado="false"
            @click="voltar()"
          />                    
          <div class="titulo-detalhes-cabecalho"> Detalhes Orçamento - {{ numeroSolicitacao }} - {{ TipoDoOrcamento }} </div>        
        </div>        

        <div class="header-icons">          
          <g-button
            largura="38px"
            altura="36px"
            tamanhoIcone="18px"
            negritoTexto
            icone="icone_compartilhar.svg"
          />          
          <g-button
            largura="38px"
            altura="36px"
            tamanhoIcone="18px"
            negritoTexto
            v-on:acao="imprimir"
            icone="icone_print.svg"
          />        
        </div>      
      </div>      
      
      <div class="conteudo-card-orcamento-informacao espacamento-detalhes">        
        <div class="parametros-titulo titulo-grupo-detalhes"> PARÂMETROS </div>        

        <div class="grupo-parametros">                    
          <div class="parametros-numero-solicitacao">            
            <div class="titulo-conteudo-detalhes"> Nº Solicitação </div>            
            <div class="label-conteudo">{{ numeroSolicitacao }}</div>          
          </div>          
          
          <div class="parametros-unidade">            
            <div class="titulo-conteudo-detalhes"> Unidade </div>            
            <div class="label-conteudo">{{ nomeEmpresa }}</div>          
          </div>          
          
          <div class="parametros-representante">            
            <div class="titulo-conteudo-detalhes"> Representante </div>            
            <div class="label-conteudo">{{ nomeRepresentante }}</div>          
          </div>          
          
          <div class="parametros-data-digitacao">            
            <div class="titulo-conteudo-detalhes"> Data Digitação </div>           
            <div class="label-conteudo">{{ dataDigitacaoFormatadaConsulta }}</div>          
          </div>          
          
          <div class="parametros-data-retorno">            
            <div class="titulo-conteudo-detalhes"> Data Retorno </div>            
            <div class="label-conteudo">{{ dataAlteracao }}</div>          
          </div>          
          
          <div class="parametros-status">            
            <div class="titulo-conteudo-detalhes"> Status </div>            
            <div class="label-conteudo">{{ statusText }}</div>          
          </div>        
        </div>        

        
        <div class="titulo-grupo-detalhes"> OBS. DA NEGOCIAÇÃO </div>
        
        <div class="dados_observacoes">
          <div class="obs-neg">
            <div class="label-conteudo" 
              v-for="obs in this.ObservacoesNegociacaoOriginalTextoCortado "
              :key="obs.id"
            > 
              {{obs || 'Não Cadastrado'}}
            </div>
          </div>

          <div class="obs-prod">
            <div class="titulo-conteudo-detalhes"> Observações do Produto </div>
            <div class="resultado-observacao observacao-produto">{{this.observacoesNegociacao.observacaoProduto}}</div>
          </div>
        </div>


        <div class="titulo-grupo-detalhes"> CLIENTE </div>     

        <div class="grupo-cliente">          
          <div class="cliente-cnpj">            
            <div class="titulo-conteudo-detalhes"> CNPJ </div>            
            <div class="label-conteudo">{{ cnpj }}</div>          
          </div>          
      
          <div class="cliente-codigo">            
            <div class="titulo-conteudo-detalhes"> Código </div>            
            <div class="label-conteudo">{{ codigoUsuario }}</div>          
          </div>          
      
          <div class="cliente-razao-social">            
            <div class="titulo-conteudo-detalhes"> Razão Social </div>            
            <div class="label-conteudo">{{ razaoSocial }}</div>          
          </div>          
          
          <div class="cliente-estado">            
            <div class="titulo-conteudo-detalhes"> Estado </div>            
            <div class="label-conteudo">{{ siglaEstado }}</div>          
          </div>         
          
          <div class="cliente-cidade">            
            <div class="titulo-conteudo-detalhes"> Cidade </div>            
            <div class="label-conteudo">{{ nomeCidade }}</div>          
          </div>         
          
          <div class="cliente-segmento">            
            <div class="titulo-conteudo-detalhes"> Segmento </div>            
            <div class="label-conteudo">{{ segmentoFormat }}</div>          
          </div>          
          
          <div class="cliente-contato">            
            <div class="titulo-conteudo-detalhes"> Contato </div>            
            <div class="label-conteudo">{{ nomeContato || "Não cadastrado" }}</div>          
          </div>          
          
          <div class="cliente-telefone">            
            <div class="titulo-conteudo-detalhes"> Telefone </div>            
            <div class="label-conteudo">{{ numeroTelefone || numeroCelular }}</div>          
          </div>          
          
          <div class="cliente-ramal">            
            <div class="titulo-conteudo-detalhes"> Ramal </div>            
            <div class="label-conteudo">{{ numeroRamal || "Não Possui" }}</div>          
          </div>          
      
          <div class="cliente-suframa">            
            <div class="titulo-conteudo-detalhes"> Suframa </div>            
            <div class="label-conteudo">{{ numeroSuframa || "Não Possui" }}</div>          
          </div>          
          
          <div class="cliente-incentivo-fiscal">            
            <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal? </div>            
            <div class="label-conteudo">{{icms + ipi + piscofins == "" ? "NÃO" : icms + ipi + piscofins}}</div>          
          </div>        
        </div>        
        
      
        <div class="loteFrete-titulo titulo-grupo-detalhes"> LOTE E FRETE </div>  

        <div class="grupo-loteFrete">       
          <div class="loteFrete-frete">            
            <div class="titulo-conteudo-detalhes"> Frete </div>            
            <div class="label-conteudo">{{ freteEnum }}</div>          
          </div>          
          
          <div class="loteFrete-cep">            
            <div class="titulo-conteudo-detalhes"> CEP </div>            
            <div class="label-conteudo">{{ cep || "Não Cadastrado" }}</div>          
          </div>          
          
          <div class="loteFrete-cidade">            
            <div class="titulo-conteudo-detalhes"> Cidade </div>            
            <div class="label-conteudo">{{ this.nomeCidadeFrete }}</div>          
          </div>          
          
          <div class="loteFrete-estado">            
            <div class="titulo-conteudo-detalhes"> UF </div>            
            <div class="label-conteudo">{{ this.SiglaEstadoFrete }}</div>          
          </div>          
          
          <div class="loteFrete-tipo-frete">            
            <div class="titulo-conteudo-detalhes"> Tipo Frete </div>            
            <div class="label-conteudo">{{ tipoFreteEnum || "Não cadastrado" }}</div>          
          </div>        

          <div class="loteFrete-riscoFaca-prototipo" v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">            
            <div class="riscoFaca-prototipo titulo-conteudo-detalhes"> Risco Faca </div>            
            <div class="riscoFaca-prototipo label-conteudo">{{ riscoFacaPrototipo }}</div>          
          </div>  

          <div class="loteFrete-lote">            
            <div class="titulo-conteudo-detalhes"> Lote </div>            
            <div class="label-conteudo">{{ informacaoLoteText }}</div>          
          </div>          
          
          <div class="loteFrete-descricao-lote">            
            <div class="titulo-conteudo-detalhes"> Descrição Lote </div>            
            <div class="lote label-conteudo">{{ DescricaoLote || 'Não Possui' }}</div>          
          </div>          
          
          <div class="loteFrete-sequencia">            
            <div class="titulo-conteudo-detalhes"> Sequência </div>            
            <div class="label-conteudo">{{ getSequencia }}</div>          
          </div>          
          
          <div class="loteFrete-descricao-sequencia">            
            <div class="titulo-conteudo-detalhes"> Descrição Sequência </div>     
            <div class="conteudo-desc-sequencia">
              <div class="label-conteudo label-sequencia">{{ OrcamentoDescricaoSequencia || 'Não Possui' }}</div>               
              
              <div class="label-conteudo-resumo-final">
                <div 
                  v-for="data in InformacaoProdutosSequencia"
                  :key="data.produtoId"
                >
                  {{ data.tipo }} / {{data.codigoExterno}} - {{data.produto}} 
                </div>
              </div>
            </div>       
          </div>              
        </div>              
        

        <div class="infoBasicas-titulo titulo-grupo-detalhes"> INFORMAÇÕES BÁSICAS </div>      

        <div class="grupo-infoBasicas">          
          <div class="infoBasicas-imagemProduto" v-if="temImagem">
            <PImage 
              :imageStyle="styleImg" 
              v-on:error="erro($event)" 
              :src="caminhoImagem" 
              :preview="true"
            />
            <div class="img-info-mobile" v-if="this.styleImg.includes('100')"> NENHUMA IMAGEM DISPONÍVEL! </div>    
          </div>          
    
          <div class="infoBasicas-nome-produto">            
            <div class="titulo-conteudo-detalhes"> Nome do Produto </div>            
            <div class="label-conteudo">{{ nomeProduto }}</div>          
          </div>          

          <div class="infoBasicas-quantidade-data">
            <div class="infoBasicas-quantidade">            
              <div class="titulo-conteudo-detalhes"> Quantidade </div>            
              <div class="label-conteudo" v-for="data in OrcaQuantidade" :key="data.id">{{ formataDecimal(data.quantidade) }}</div>          
            </div>          
          
            <div class="infoBasicas-diaCarregamento">            
              <div class="titulo-conteudo-detalhes"> Dia Carregamento </div>            
              <div class="diaCarregamento label-conteudo" v-for="data in OrcaQuantidadeDiaCarregamento" :key="data.id">{{ data.dataCarregamentoFormato }}</div>          
            </div>          
          </div>
    
          <div class="infoBasicas-amostraRef">            
            <div class="parametros-titulo titulo-conteudo-detalhes"> Deseja utilizar amostra de referência? </div>  

            <div class="checkbox-filtros">              
              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoAmostra"
                /> 

                <label class="label-checkbox" for="amostra"> Acompanha amostra </label>              
              </div>              
              
              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoAmostraEspTecnica"
                />

                <label class="label-checkbox" for="especificacoes"> Todas as especificações técnicas conforme amostra </label>              
              </div>              
              
              <div class="input-checkbox">                
                <PCheckBox 
                disabled
                :binary="true"
                v-model="OrcamentoAmostraOutros"
                />

                <label class="label-checkbox" for="outros"> Outros materiais do cliente </label>              
              </div>              

              <div class="descricao-outros-materiais input-checkbox">                
                <label class="label-checkbox" for="outros-embalagens">{{ OrcamentoAmostraDescOutros }}</label>              
              </div>            
            </div>          
          </div>                 
        </div> 

        <div class="infoBasicas-observacao"> <!-- v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">             -->
          <div class="observacao titulo-conteudo-detalhes"> Obs. sobre Quantidade / Carregamento / Consumo </div>          

          <PTextArea
            disabled
            style="width: 100%"
            id="obsInfoBasicas"
            rows="5"
            cols="40"
            v-model="InformacaoObservacao"
          />
        </div>                    

        <div class="titulo-grupo-detalhes titulo-componentes" v-if="componentesLista.length > 0"> COMPONENTES </div>

        <div class="content-componentes">
          <div 
            class="box-componente" 
            v-for="(data, index) in componentesLista"
            :key="data"
          >
            <div class="imagem-numero-nome-componente">
              <div class="imagem-grupo-componente">
                <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
              </div>
              
              <div class="numero-nome-componente">
                <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
              </div>
            </div> 

            <div class="grupo-componentes">
              <div class="componentes-medidas">
                <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                <div class="medidas label-conteudo"
                >
                {{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)  ? data.numeroComprimento + 'x' + data.numeroLargura + 'x' + data.numeroAltura + 'x' + data.numeroAlturaTampa  : data.descricaoMedidasTexto }}

                  <!-- {{ data.descricaoMedidasTexto == '' ? data.numeroComprimento + 'x' + data.numeroLargura + 'x' + data.numeroAltura + 'x' + data.numeroAlturaTampa  : data.descricaoMedidasTexto }} -->
                </div>
              </div>

              <div class="componentes-cor-frente">
                <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                <div class="corFrente label-conteudo"
                >
                  {{data.quantidadeCoresFrente != 1 ? data.quantidadeCoresFrente + ' Cores' + '  ' + data.nomeCorFrente  : data.quantidadeCoresFrente + ' Cor' + '   ' + data.nomeCorFrente }}
                </div>
              </div>

              <div class="componentes-cor-verso">
                <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                <div class="corVerso label-conteudo"
                >
                {{data.quantidadeCoresVerso != 1 ? data.quantidadeCoresVerso + ' Cores' +  '   ' +  data.nomeCorVerso : data.quantidadeCoresVerso + ' Cor'  + '  ' + data.nomeCorVerso}}
                </div>
              </div>

              <div class="componentes-acabFrente">
                <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
              </div>

              <div class="componentes-acabVerso">
                <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
              </div>

              <div class="componentes-material">
                <div class="material titulo-conteudo-detalhes"> Material </div>
                <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
              </div>

              <div class="componentes-onda">
                <div class="onda titulo-conteudo-detalhes"> Onda </div>
                <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
              </div>

              <div class="componentes-capaExt">
                <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
              </div>

              <div class="componentes-gramaturaExt">
                <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura </div>
                <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
              </div>

              <div class="componentes-capaInt">
                <div class="capaInt titulo-conteudo-detalhes">  Papel de Onda </div>
                <div class="capaInt label-conteudo">{{ data.descricaoPapelOndaTexto }} </div>
              </div>

              <div class="componentes-gramaturaInt">
                <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura </div>
                <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
              </div>

              <div class="componentes-papelOnda">
                <div class="papelOnda titulo-conteudo-detalhes"> Capa Interna </div>
                <div class="papelOnda label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
              </div>

              <div class="componentes-gramaturaPO">
                <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura </div>
                <div class="gramaturaPO label-conteudo"> {{ data.numeroGramaturaCapaInterna }}</div>
              </div>

              <!-- <div class="componentes-codigo" v-if="data.descricaoSistema == 0">
                <div class="codigo-componente titulo-conteudo-detalhes"> Código </div>
                <div class="label-conteudo">{{ data.codigoSistema }}</div>
              </div> -->

              <div class="componentes-descricao">
                <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                <div class="label-conteudo">{{ data.sistema }}</div>
              </div>

              <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                <div class="label-conteudo">{{ data.produtoSistema }}</div>
              </div>

              <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                <div class="label-conteudo">{{ data.prototipoSistema }}</div>
              </div>

              <div class="componentes-embalagem-coletiva" 
                v-if="data.embalagemPalete == true || 
                data.embalagemFilmeEncolhivel == true || 
                data.embalagemCaixaColetiva == true || 
                data.embalagemPapelEmbrulho == true || data.quantidadeOutros != 0"
              >
                <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                <div class="labels-embalagem-coletiva">
                  <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                  >
                    {{ texto }}
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="titulo-grupo-detalhes"> DEMAIS CARACTERÍSTICAS </div>        

        <div class="grupo-demaisCaract">          
          <div class="demaisCaract-gerais">            
            <div class="titulo-conteudo-detalhes"> Gerais </div>       

            <div class="checkbox-filtros">              
              <div class="input-checkbox">               
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoGeraisFsc"
                />

                <label class="label-checkbox" for="FSC"> Cliente exige selo FSC nesse produto </label>              
              </div>   

              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoGeraisLegislacao"
                />

                <label class="label-checkbox" for="legislacao"> Existe legislação ou requisito regulamentar específico </label>              
              </div>                      
            </div>          
          </div>          
          
          <div class="demaisCaract-embalagem" v-if="this.tipoFluxoOrcamento !== 1">            
            <div class="titulo-conteudo-detalhes"> Embalagem coletiva específica </div>     

            <div class="checkbox-filtros">              
              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoEmbalagemFilme"
                />
                        
                <label class="label-checkbox" for="filme-encolhivel"> Filme encolhível </label>              
              </div>              
              
              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoEmbalagemCaixaColetiva"
                />

                <label class="label-checkbox" for="caixa-coletiva"> Caixa coletiva </label>              
              </div>              
              
              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoEmbalagemPalete"
                />

                <label class="label-checkbox" for="palete"> Palete </label>              
              </div> 
              
              <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                <PCheckBox :binary="true" v-model="MelhorAproveitamento" disabled="DesabilitaCheckBox"/>
                <label class="label-checkbox"> Melhor Aproveitamento </label>
              </div>
              
              <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                <label class="label-checkbox"> C: {{ComprimentoPalete}} X L: {{LarguraPalete}} X A: {{AlturaPalete}} </label>
                <label class="label-checkbox"> {{ObservacaoPalete}} </label>
              </div>
              
              <div class="input-checkbox">                
                <PCheckBox 
                  disabled
                  :binary="true"
                  v-model="OrcamentoEmbalagemOutros"
                />

                <label class="label-checkbox" for="embalagem-outros"> Outros </label>              
              </div>            

              <div class="descricao-outros-embalagens input-checkbox">                
                <label class="label-checkbox" for="descricao-outros-embalagens">{{ OrcamentoEmbalagemDescOutros }}</label>              
              </div>            
            </div>          
          </div>          
          
          <div class="demaisCaract-critica" v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">            
            <div class="titulo-conteudo-detalhes"> Crítica de processo </div>            
            <div class="checkbox-filtros checklist-filtros-critica">              
              <div class="input-checkbox critica-container">                             
                <label class="label-checkbox" for="fechamento-maquina"
                > 
                  O produto terá fechamento por máquina por parte do cliente? 
                </label>          

                <label :class="`label-checkbox critica-bool ${OrcamentoCritica3 ? 'botao-positivo' : 'botao-negativo'}`" for="fechamento-maquina">
                  {{ OrcamentoCritica3 ? "SIM" : "NÃO" }}
                </label>     
              </div>                              
            </div>          
          </div>

          <div class="demaisCaract-observacoes" v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">            
            <div class="titulo-conteudo-detalhes"> Observações </div>            

            <PTextArea
              style="width: 100%"
              disabled
              rows="5"
              cols="40"
              v-model="observacoesGerais"
            />
          </div>        
        </div>   


        <div class="titulo-grupo-detalhes"> ORÇAMENTO </div>   

        <div class="grupo-orcamento">          
          <div class="orcamento-porcentagem-financeira">            
            <div class="titulo-conteudo-detalhes"> % Financeira </div>            
            <div class="label-conteudo">{{ porcentagemFinanceira }}</div>          
          </div>          
        
          <div class="orcamento-prazo-maximo">            
            <div class="titulo-conteudo-detalhes"> Prazo máximo </div>            
            <div class="label-conteudo">{{ prazoMaximo }}</div>          
          </div>          
        
          <div class="orcamento-forma-pagamento">                        
            <div class="titulo-conteudo-detalhes"> Forma de Pagamento </div>            
            <div class="label-conteudo">{{ formaPagamento }}</div>          
          </div>          
        
          <div class="orcamento-gramatura">            
            <div class="titulo-conteudo-detalhes"> Gramatura </div>            
            <div class="label-conteudo">{{ gramatura }}</div>          
          </div>          
        
          <div class="orcamento-data-hora">            
            <div class="titulo-conteudo-detalhes"> Data / Hora </div>            
            <div class="label-conteudo">{{ dataEHora }}</div>          
          </div>        
        </div>        
          
        <div class="linha-separacao"></div>    

        <div class="duas-tabelas">
          <div class="orcamento-tabela-conteudo">
            <div class="titulo-conteudo-detalhes alinhando-titulo-ideal"> Ideal </div>
            
            <div class="orcamento-tabela">
              <div class="coluna-quantidade">
                <div class="titulo-conteudo-detalhes titulo-tabela-quantidade"> Quantidade </div>
                <div class="label-conteudo" v-for="data in quantidadePrecoArray" :key="data.orcamentoQuantidadeId">{{ formataDecimal(data.quantidade) }}</div>
              </div>
        
        
              <div class="coluna-preco">
                <div class="titulo-conteudo-detalhes titulo-tabela-preco"> Preço </div>
                <div class="label-conteudo" v-for="data in quantidadePrecoArray" :key="data.orcamentoQuantidadeId">{{ formataMonetario(data.precoFormatado) }}</div>
              </div>
        
              <div class="coluna-comissao">
                <div class="titulo-conteudo-detalhes titulo-tabela-comissao"> Comissão </div>
                <div class="label-conteudo" v-for="data in quantidadePrecoArray" :key="data.orcamentoQuantidadeId">{{ data.comissaoFormatado }}%</div>
              </div>
            </div>
          </div>
                  
        </div>
          
        <PDialog
          id="popupMotivo"
          class="popupsair"
          :closable="false"
          :showHeader="false"
          v-model:visible="popupRejeitado"
          :modal="true"
          :style="{ width: '50vw' }"
        >          
          <div class="titulo_PopupRejeitado"> MOTIVO DA PERDA </div>          
          <div class="subtitulo_PopupRejeitado"> Descreva o motivo do orçamento não ter sido aceito </div>          
      
          <div class="resultado">            
            <PTextArea 
              class="area-obs-informacao-basica" 
              rows="5" 
              cols="40"
            />                          
          </div>          

          <div class="cancela-informar">            
            <div class="cancelar">              
              <g-button
                class="Botao-cancelar-popup"
                :sombreado="false"
                tipo="cinza"
                @click="sairPopUp"
              >                
                <div class="cancela-popup"> CANCELAR </div>              
              </g-button>            
            </div>            
        
            <div class="informar-motivo">              
              <g-button class="Botao-informar-motivo-popup" :sombreado="false">                
                <div class="informar-popup"> INFORMAR MOTIVO </div>              
              </g-button>            
            </div>          
          </div>                  
        </PDialog>      
      </div>   
    </g-card>  
  </div>

  <g-pdf :pdfFloat="false" :NovaGuia="true"  :executar="executarvisualizacao">
    <div class="render" v-if="renderiza">
      <ConsultarOrcamentoPDF :PropstyleImg= "this.styleImg" :PropcaminhoImagem="this.caminhoImagem" :tituloDetalhes="false" v-on:termino="gerarPdf" :orcamentoId="OrcamentoSelecionado"></ConsultarOrcamentoPDF>
    </div>
  </g-pdf>
</template>
    
<script>
import OrcamentoInformacao from "./OrcamentoInformacao.js";
export default OrcamentoInformacao;
</script>

<style scoped>
.grupo-parametros,
.grupo-cliente,
.grupo-loteFrete,
.grupo-infoBasicas,
.grupo-componentes,
.grupo-demaisCaract,
.grupo-orcamento {
  margin-top: 0.2rem;
}

.infoBasicas-imagemProduto {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem;
}

.grupo-demaisCaract .titulo-conteudo-detalhes {
  padding-bottom: 0.5rem;
}

.content-componentes {
    width: 100%;
    display: grid;
    gap: 1.5rem;
}
.box-componente {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente .grupo-componentes {
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
}

.titulo-componentes {
  margin-bottom: 1.5rem;
}
.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
}

.grupo-componentes .titulo-conteudo-detalhes {
  color: #3f3f3f !important;
  font-size: 0.9rem !important;
  margin-top: 0.5rem !important;
}

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

.critica-bool {
  color: #F9F9F9;
  width: max-content;
  padding: 0.2rem 1rem;
  border-radius: 0.2rem;
}

.botao-positivo {
  background-color: #3dca55;
}
.botao-negativo {
  background-color: #DC4242;
}

.critica-container .label-checkbox {
  margin-left: 0 !important;
}

.obs-neg {
  margin-top: 1.1rem;
}

.alinhando-titulo-ideal {
  justify-items: center;
  text-align: center;
  background-color: #E3E3E3;
  padding: 0.5rem 0;
  border-radius: 0.5rem 0.5rem 0 0;
}

.duas-tabelas {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}

.observacao-produto {
  font-family: monospace;
  max-width: 50ch;
  white-space: break-spaces;
}

.resultado-observacao {
  text-align: left;
  letter-spacing: 0px;
  color: #8a8a8a;
  opacity: 1;
  font-size: 16px;
}

.agrupa_tudo{
  display: flex;
  gap: 1rem;
  border-bottom: 2px solid #c4bfbf4d;
}

.img-info-mobile {
  font-size: 13px;
  font-family: "MontSerrat";
  letter-spacing: 0px;
  color: #CECECE;
  width: auto;
  margin: 10px 10px;
}
.container-logo {
  padding: 30px 30px 10px 53px;
}
.input-checkbox {
  padding: 1px 0;
}

.linha-separacao {
  margin: 15px 0;
}

.critica-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.orcamento-tabela-conteudo {
  border-radius: 0.5rem;
}

.orcamento-tabela {
  background-color: #F9F9F9;
  padding: 0 1rem 1rem;
}

@media (min-width: 310px) {
.orcamento-tabela {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 50px;
}

.infoBasicas-quantidade-data {
  display: flex;
  flex-direction: column;
  column-gap: 20px;
}

.grupo-infoBasicas {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(v-bind(RetornaQtdLinha1()), auto);
  grid-column-gap: 20px;
}
.infoBasicas-imagemProduto { grid-area: 1 / 1 / 3 / 2; }
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto1()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData1()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef1()) }

.img-componente {
  height: 2.5rem;
  width: auto;
}
}

@media (min-width: 400px) {
.titulo-componente {
  text-align: left;
  font-weight: bold;
  color: #4f2c19;
  justify-content: space-between;
  height: 10%;
  display: flex;
  align-items: center;
  background-color: #fcb316;
  width: 25px;
  justify-content: center;
}
.infoBasicas-quantidade-data {
  display: grid;
  grid-template-columns: 30% auto;
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
}

@media (min-width: 450px) {
.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
}

@media (min-width: 500px) {
.grupo-parametros {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.parametros-numero-solicitacao { grid-area: 1 / 1 / 2 / 2; }
.parametros-unidade { grid-area: 1 / 2 / 2 / 3; }
.parametros-representante { grid-area: 2 / 1 / 3 / 2; }
.parametros-data-digitacao { grid-area: 2 / 2 / 3 / 3; }
.parametros-data-retorno { grid-area: 3 / 1 / 4 / 2; }
.parametros-status { grid-area: 3 / 2 / 4 / 3; }

.grupo-cliente {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(6, auto);
  grid-column-gap: 20px;
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 2 / 1 / 3 / 2; }
.cliente-estado { grid-area: 2 / 2 / 3 / 3; }
.cliente-cidade { grid-area: 3 / 1 / 4 / 2; }
.cliente-segmento { grid-area: 3 / 2 / 4 / 3; }
.cliente-contato { grid-area: 4 / 1 / 5 / 2; }
.cliente-telefone { grid-area: 4 / 2 / 5 / 3; }
.cliente-ramal { grid-area: 5 / 1 / 6 / 2; }
.cliente-suframa { grid-area: 5 / 2 / 6 / 3; }
.cliente-incentivo-fiscal { grid-area: 6 / 1 / 7 / 2; }

.grupo-orcamento {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.orcamento-porcentagem-financeira { grid-area: 1 / 1 / 2 / 2; }
.orcamento-prazo-maximo { grid-area: 1 / 2 / 2 / 3; }
.orcamento-forma-pagamento { grid-area: 2 / 1 / 3 / 2; }
.orcamento-gramatura { grid-area: 2 / 2 / 3 / 3; }
.orcamento-data-hora { grid-area: 3 / 1 / 4 / 2; }
}

@media (min-width: 600px) {
.grupo-loteFrete {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;  
}
.loteFrete-tipo-frete { grid-column: span 2; }

.content-componentes {
  grid-template-columns: repeat(2, minmax(2rem, 1fr));
}

.componentes-produto, 
.componentes-embalagem-coletiva { grid-column: span 2; } 
}

@media (min-width: 700px) {
.checkbox-filtros {
  flex-direction: column;
}

.grupo-parametros {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.parametros-representante { grid-area: 1 / 3 / 2 / 4; }
.parametros-data-digitacao { grid-area: 2 / 1 / 3 / 2; }
.parametros-data-retorno { grid-area: 2 / 2 / 3 / 3; }
.parametros-status { grid-area: 2 / 3 / 3 / 4; }

.grupo-cliente {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(11, auto);
}
.cliente-razao-social { grid-area: 1 / 3 / 2 / 4; }
.cliente-estado { grid-area: 2 / 1 / 3 / 2; }
.cliente-cidade { grid-area: 2 / 2 / 3 / 3; }
.cliente-segmento { grid-area: 2 / 3 / 3 / 4; }
.cliente-contato { grid-area: 3 / 1 / 4 / 2; }
.cliente-telefone { grid-area: 3 / 2 / 4 / 3; }
.cliente-ramal { grid-area: 3 / 3 / 4 / 4; }
.cliente-suframa { grid-area: 4 / 1 / 5 / 2; }
.cliente-incentivo-fiscal { grid-area: 4 / 2 / 5 / 3; }

.grupo-infoBasicas {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind(RetornaQtdLinha2()), auto);
}
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto2()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData2()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef2()) }

.grupo-orcamento {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.orcamento-forma-pagamento { grid-area: 1 / 3 / 2 / 4; }
.orcamento-gramatura { grid-area: 2 / 1 / 3 / 2; }
.orcamento-data-hora { grid-area: 2 / 2 / 3 / 3; }
}

@media (min-width: 801px) {
.grupo-loteFrete {
  grid-template-columns: repeat(3, 1fr);
}
.loteFrete-descricao-lote, .loteFrete-descricao-sequencia { grid-column: span 2; }

.grupo-orcamento {  
  grid-template-columns: repeat(4, minmax(4em, 1fr));
}
.orcamento-gramatura { grid-area: 1 / 4 / 2 / 5; }
.orcamento-data-hora { grid-area: 2 / 1 / 3 / 2; }
}

@media (min-width: 1025px) {
.grupo-loteFrete {
  grid-template-columns: repeat(4, 1fr);
}
.loteFrete-tipo-frete { grid-column: span 4; }
.loteFrete-descricao-lote, .loteFrete-descricao-sequencia { grid-column: span 3; }
.label-conteudo-resumo-final {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 3rem;
}

.titulo-componente {
  margin-top: 30px;
  text-align: left;
  font-weight: bold;
  background-color: white;
}

.grupo-parametros {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
}
.parametros-data-digitacao { grid-area: 1 / 4 / 2 / 5; }
.parametros-data-retorno { grid-area: 2 / 1 / 3 / 2; }
.parametros-status { grid-area: 2 / 2 / 3 / 3; }


.grupo-cliente {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
}
.cliente-estado { grid-area: 1 / 4 / 2 / 5; }
.cliente-cidade { grid-area: 2 / 1 / 3 / 2; }
.cliente-segmento { grid-area: 2 / 2 / 3 / 3; }
.cliente-contato { grid-area: 2 / 3 / 3 / 4; }
.cliente-telefone { grid-area: 2 / 4 / 3 / 5; }
.cliente-ramal { grid-area: 3 / 1 / 4 / 2; }
.cliente-suframa { grid-area: 3 / 2 / 4 / 3; }
.cliente-incentivo-fiscal { grid-area: 3 / 3 / 4 / 4; }

.content-componentes {
  column-gap: 4rem;
}
.imagem-numero-nome-componente {
    padding: 0.5rem 1rem;
}
.grupo-componentes {
    padding: 0 1rem;
}

.grupo-demaisCaract {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.demaisCaract-gerais { grid-area: 1 / 1 / 2 / 2; }
.demaisCaract-embalagem { grid-area: 1 / 2 / 2 / 3; }
.demaisCaract-critica { grid-area: 2 / 1 / 3 / 3; }
.demaisCaract-observacoes { grid-area: 3 / 1 / 4 / 3; }


.grupo-orcamento {
  grid-template-columns: repeat(5, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.orcamento-gramatura { grid-area: 1 / 4 / 2 / 5; }
.orcamento-data-hora { grid-area: 1 / 5 / 2 / 6; }
}

@media (min-width: 1281px) {
.content-componentes {
  grid-template-columns: repeat(3, minmax(2rem, 1fr));
  column-gap: 1.5rem;
}

.imagem-numero-nome-componente, .grupo-componentes {
  padding: 0;
}

.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
.componentes-embalagem-coletiva { grid-column: span 2; }

.grupo-infoBasicas {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind(RetornaQtdLinha2()), auto);
}
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto3()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData3()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef3()) }
}

@media (min-width: 1400px) {
.grupo-parametros {
  grid-template-columns: repeat(5, minmax(4em, 1fr));
  grid-template-rows: repeat(2, 1fr);
}
.parametros-data-retorno { grid-area: 1 / 5 / 2 / 6; }
.parametros-status { grid-area: 2 / 1 / 3 / 2; }

.grupo-cliente {
  grid-template-columns: repeat(5, minmax(4em, 1fr));
}
.cliente-cidade { grid-area: 1 / 5 / 2 / 6; }
.cliente-segmento { grid-area: 2 / 1 / 3 / 2; }
.cliente-contato { grid-area: 2 / 2 / 3 / 3; }
.cliente-telefone { grid-area: 2 / 3 / 3 / 4; }
.cliente-ramal { grid-area: 2 / 4 / 3 / 5; }
.cliente-suframa { grid-area: 2 / 5 / 3 / 6; }
.cliente-incentivo-fiscal { grid-area: 3 / 1 / 4 / 2; }

.grupo-demaisCaract {
  grid-template-columns: 1.5fr 1fr 2fr;
  grid-template-rows: repeat(2, auto);
}
.demaisCaract-critica { grid-area: 1 / 3 / 2 / 4; }
.demaisCaract-observacoes { grid-area: 2 / 1 / 3 / 5; }

.grupo-orcamento {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
}
}

@media (min-width: 1500px) {
.grupo-loteFrete {
  grid-template-columns: repeat(5, 1fr);
}
.loteFrete-tipo-frete { grid-column: span 1; }
.loteFrete-descricao-lote, .loteFrete-descricao-sequencia { grid-column: span 4; }

.grupo-infoBasicas {
  grid-template-columns: repeat(v-bind(RetornaQtdColuna()), minmax(4em, 1fr));
}

.content-componentes {
  grid-template-columns: repeat(4, minmax(2rem, 1fr));
}
}

@media (min-width: 1600px) {
.grupo-infoBasicas {
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind(RetornaQtdLinha4()), auto);
}

.titulo-componente {
  margin-top: 30px;
  text-align: left;
  font-weight: bold;
  background-color: white;
}
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto4()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData4()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef4()) }
}

@media (min-width: 1800px) {
.grupo-parametros {
  grid-template-columns: repeat(7, minmax(4em, 1fr));
  grid-template-rows: auto;
}

.parametros-status { grid-area: 1 / 6 / 2 / 7; }

.grupo-cliente {
  grid-template-columns: repeat(7, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.cliente-segmento { grid-area: 1 / 6 / 2 / 7; }
.cliente-contato { grid-area: 1 / 7 / 2 / 8; }
.cliente-telefone { grid-area: 2 / 1 / 3 / 2; }
.cliente-ramal { grid-area: 2 / 2 / 3 / 3; }
.cliente-suframa { grid-area: 2 / 3 / 3 / 4; }
.cliente-incentivo-fiscal { grid-area: 2 / 4 / 3 / 5; }

.grupo-orcamento {
  grid-template-columns: repeat(7, minmax(4em, 1fr));
}
}

@media (min-width: 2000px) {
.grupo-demaisCaract {
  grid-template-columns: 1.5fr 1fr 2fr 1fr;
  grid-template-rows: repeat(2, auto);
}
}
</style>